// M003 quick finder
function initQuickfinder() {
    window._pants = window._pants || {};
    var quickFinderOpts = window._pants.quickFinderOpts = {};



    if ($(".quickFinderPlayButton").length > 0) {
		$(".quickFinderPlayButton").each(function(){
            $(this).click(function(){
                if($(this).hasClass("pause-icon")){
                    $(this).removeClass("pause-icon");
                    $(this).parent(".quickFinderImageContainer").addClass("paused")
                }
                else{
                    $(this).addClass("pause-icon");
                    $(this).parent(".quickFinderImageContainer").removeClass("paused")
                }
            });
            $(this).on("keydown", function(e){
                if(e.which && (e.which == 9 || e.which == 16)){
                    return;
                }
                $(this).trigger("click");
            });
        });
    }

    if ($(".quickFinderImageContainer").length > 0) {
		$(".quickFinderImageContainer").each(function(){

			
			if($(this).children(".quickFinderImage").length > 1){

				//set intervall for animation
				setInterval(showNextQuickFinderImage, 5000);
			}
			else if($(this).children(".quickFinderImage").length == 1){
				$(this).children(".quickFinderImage").removeClass("invisible");
				$(this).children(".quickFinderImage").addClass("active");
			}
		});
	}

    if ($(".quickFinderTabContentContainer").length > 0) {

		$(".quickFinderTabContentContainer").each(function(){
			if($(this).children(".quickFinderTabContent").length > 1){

				$(this).slick({
					dots: false,
					infinite: false,
                    speed: 300,
					draggable: true,
					slidesToShow: 1,
					centerMode: true,
					centerPadding: '0',
					variableWidth: false,
					adaptiveHeight: false,
					prevArrow: slickPrevArrowCode,
					nextArrow: slickNextArrowCode,
                    mobileFirst: true,
					responsive: [
						{
							breakpoint: _breakpointMedium,
							settings: "unslick"
						}
					]
				});
                $(".quickFinderTabContent.slick-current").attr("aria-hidden", "false");

                $(this).on("afterChange", function () {
                    $(".quickFinderTabContent.slick-current").attr("aria-hidden", "false");
                });

				$(".quickFinderTab").click(function (e) {
					e.preventDefault();
					$(".quickFinderTab").removeClass("active");
					$(this).addClass("active");
					var i = $(".quickFinderTab").index($(this));
					//$(".quickFinderTabContentContainer").slick('slickGoTo', i);

                    $(".quickFinderTabContentContainer").find(".quickFinderTabContent").hide();
                    $(".quickFinderTabContentContainer").find(".quickFinderTabContent").find("a").attr("tabindex", "-1");
                    
                    $(".quickFinderTabContentContainer").find(".quickFinderTabContent").eq(i).show();
                    $(".quickFinderTabContentContainer").find(".quickFinderTabContent").eq(i).find("a").attr("tabindex", "0");
				});
                $(".quickFinderTab").on("keydown", handleKeyDownForClick);

			}
			else{
                $(this).children(".quickFinderTabContent").removeClass("quickFinderTabContent--noslick");
				$(this).children(".quickFinderTabContent").addClass("quickFinderTabContent--noslick");
			}
            
            $(this).children(".quickFinderTabContent").first().find("a").attr("tabindex", "0");
		});

    }


    if ($(".productFinderContainer").length > 0) {

        $(".productFinderContainer").each(
            function () {
                var $select1 = $(this).find("#quickfinderSelectbox1");
                var $select2 = $(this).find("#quickfinderSelectbox2");

                var $niceSelect1 = $select1.siblings(".nice-select");
                var $niceSelect2 = $select2.siblings(".nice-select");

                var $niceList2 = $('.list', $niceSelect2);


                if($niceList2.length) {
                    $niceList2.css('visibility', 'hidden');
                    quickFinderOpts.listHeight = $niceList2.get(0).getBoundingClientRect().height;
                    $niceList2.css('visibility', 'visible');
                }

                $(this).find(".formField").click(function () {
                    $(".productFinderSection").removeClass("opened");
                    $(this).closest(".productFinderSection").addClass("opened");
                });


                //reset select boxes
                if ($select1.length > 0) {

                    $(".option", $niceSelect1).removeClass("selected");
                    $(".option", $niceSelect1).first().addClass("selected");
                    $(".current", $niceSelect1).html($(".option", $niceSelect2).first().html());
                    
                    //hide first option 
                    $(".option", $niceSelect1).first().hide();
                }

                if ($select2.length > 0) {                   
                    //hide first option 
                    $(".option", $niceSelect2).first().hide();
                }

                $(".option", $niceSelect2).removeClass("selected");
                $(".option", $niceSelect2).first().addClass("selected");
                $(".current", $niceSelect2).html($(".option", $niceSelect2).first().html());

                if ($select1.length > 0) {

                    //disable second select box
                    $select2.attr("disabled", "disabled");
                    $niceSelect2.removeClass("disabled");
                    $niceSelect2.addClass("disabled");
                    $select2.children("option").hide();



                    //handle first select box change
                    $select1.change(function () {
                        //consolog("val:" + $(this).val());

                        if ($(this).val() != "") {

                            var dataCat = $(this).val();
                            $select2.siblings(".nice-select").find(".option").hide();

                            $select2.children("option").each(function () {
                                var i = $select2.children("option").index($(this));

                                if ($(this).attr("data-cat") == dataCat) {
                                    //consolog("i:" + i);
                                    var $li = $select2.siblings(".nice-select").find(".option").eq(i);
                                    $li.show();
                                }
                            });

                            $select2.removeAttr("disabled");
                            $select2.siblings(".nice-select").removeClass("disabled");

                            $select1.closest(".productFinderSection").removeClass("opened");
                        }
                    });

                }

                $select2.change(function () {
                    //consolog("val:" + $(this).val());
                    if ($(this).val() != "") {
                        window.location.href = $(this).val();
                    }

                    $(".productFinderSection").removeClass("opened");
                });

                $(this).find(".productFinder").children(".nice-select").click(function () {
                    var $ns = $(this);
                    handleQuickfinderClosed();

                    if (!$(this).hasClass("open")) {
                        handleQuickfinderOpened($(this));
                    }
                });
            }
        );
    }
}

function showNextQuickFinderImage(){
	$(".quickFinderImageContainer").each(function(){

        if(!$(this).hasClass("paused")){
            var $a = $(this).children(".quickFinderImage.active");
            $a.removeClass("active");
            
            var $n = $a.next(".quickFinderImage");
            
            if($n.length == 0){
                $n = $(this).children(".quickFinderImage").first();
            }
            
            if($n.hasClass("invisible")){
                $n.removeClass("invisible");
                if (_blazy) {
                    _blazy.revalidate();
                }
            }
            $n.addClass("active");
            //console.log("n:" + $n.length);
        }
	});
}

function updateQuickfinder() {

    if ($(".quickFinder").length > 0) {
        $(".quickFinder").each(function () {

            var h = Math.round($(this).find(".quickFinderTabs").outerHeight()) - 1;
            $(".quickFinder").find(".quickFinderTabs").css("margin-top", -h + "px");

            $(this).find(".quickFinderTab").each(function () {
                var w = $(this).find("span").innerWidth() + 20;
                //consolog("w:" + w + " (" + $(this).find("span").html() + ")");
                if (w > $(this).width()) {
                    w = $(this).width();
                }
                $(this).find(".quickFinderTabLine").css("width", w);
                $(this).find(".quickFinderTabLine").css("margin-left", -Math.round(w / 2));
            });

        });
    }

}

function handleQuickfinderOpened($ns) {
    var offset = window._pants.quickFinderOpts.listHeight.toString() + 'px'
    $sl = $ns.closest(".slick-list");
    //$sl.css("padding-top", offset);
    //$sl.css("margin-top", "-"+offset);
    $sl.css("padding-bottom", offset);
    //$sl.css("margin-bottom", "-"+offset);
    //$sl.css("height", "auto");

    setTimeout(function () {
        //$sl.css("padding-top", offset);
        //$sl.css("margin-top", "-"+offset);
        $sl.css("padding-bottom", offset);
        //$sl.css("margin-bottom", "-"+offset);
        //$sl.css("height", "auto");
        $("body").unbind().mousedown(function (event) {
            var $target = $(event.target);
            if (!$target.hasClass("option") && !$target.hasClass("nice-select") && !$target.hasClass("list")) {
                handleQuickfinderClosed();
            }
        });
    }, 500);
}

function handleQuickfinderClosed() {
    $("body").unbind();
    $(".quickFinderTabContentContainer").find(".slick-list").css("padding-top", 0);
    $(".quickFinderTabContentContainer").find(".slick-list").css("margin-top", 0);
    $(".quickFinderTabContentContainer").find(".slick-list").css("padding-bottom", 0);
    $(".quickFinderTabContentContainer").find(".slick-list").css("margin-bottom", 0);
}

function checkQuickfinderClosed($ns) {
    if (!$ns.hasClass("open")) {
        handleQuickfinderClosed($ns)
    }
}

function updateProductFinderIcons(){
	
	updateProductFinderIcons2();
	setTimeout(updateProductFinderIcons2, 500);
	setTimeout(updateProductFinderIcons2, 1000);
}

function updateProductFinderIcons2(){
	//console.log("updateProductFinderIcons");
	if($(".productFinderIconContainer").length > 0){
		
		$(".productFinderIconContainer").each(function(){
			var labelMaxHeight = 0;
			$(this).find(".productFinderIconLabel").css("height", "auto");
			$(this).find(".productFinderIconLabel").each(function(){
				var h = $(this).height();
				if(h > labelMaxHeight){
					labelMaxHeight = h;
				}
			});
			
			if(labelMaxHeight > 0){
				$(this).find(".productFinderIconLabel").css("height", Math.ceil(labelMaxHeight) + "px");
			}
		});

	}
}